// === iPhone Quote Calculator ===

// Get pricing data from hidden table
function getPricing() {
  const pricing = {};
  const rows = document.querySelectorAll('.admin-pricing tr[data-model]');
  rows.forEach(row => {
    const model = row.getAttribute('data-model');
    pricing[model] = {};
    const inputs = row.querySelectorAll('input[data-storage]');
    inputs.forEach(input => {
      const storage = input.getAttribute('data-storage');
      pricing[model][storage] = parseFloat(input.value) || 0;
    });
  });
  return pricing;
}

// Calculate quote
function calculateQuote() {
  const model = document.getElementById('model').value;
  const storage = document.getElementById('storage').value;
  const condition = parseFloat(document.getElementById('condition').value);

  if (!model || !storage || !condition) {
    alert('Please select all options to get your quote');
    return;
  }

  const pricing = getPricing();
  const basePrice = pricing[model]?.[storage] || 0;

  if (basePrice === 0) {
    alert('This combination is not available. Please select a different storage option.');
    return;
  }

  const finalPrice = basePrice * condition;
  const condPercent = Math.round(condition * 100);
  const modelText = document.querySelector('#model option:checked').textContent;
  const storageText = document.querySelector('#storage option:checked').textContent;
  const condText = document.querySelector('#condition option:checked').textContent.split(' - ')[0];

  document.getElementById('amount').textContent = '£' + finalPrice.toFixed(2);
  document.getElementById('details').textContent = modelText + ' • ' + storageText + ' • ' + condText;
  document.getElementById('base').textContent = '£' + basePrice.toFixed(2);
  document.getElementById('cond').textContent = condPercent + '%';
  document.getElementById('final').textContent = '£' + finalPrice.toFixed(2);

  document.getElementById('result').style.display = 'block';
  document.getElementById('result').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

// Attach button click once the page is ready
document.addEventListener('DOMContentLoaded', function() {
  const quoteBtn = document.querySelector('.calculator .btn');
  if (quoteBtn) {
    quoteBtn.addEventListener('click', calculateQuote);
  }
});
